function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Cannabis_Watering",
  "data-name": "Cannabis Watering"
}, /*#__PURE__*/React.createElement("g", {
  id: "Filled"
}, /*#__PURE__*/React.createElement("path", {
  d: "m494.626 48.376-31-31a32 32 0 0 0 -45.254 0l-22.631 22.624-.059-.059-113.137 113.137 18.6 18.6-85.145 20.322v32h134.486l21.714 19.425 112.679-112.68 17.3-49.108a32 32 0 0 0 -7.553-33.261zm-31 59.506-45.257-45.255 22.631-22.627 33.941 33.941z",
  fill: "#e56161"
}), /*#__PURE__*/React.createElement("path", {
  d: "m128.029 442.187c25.714 34.487 83.571 28.74 83.571 28.74-.521-.361-17.6-38.3-59.571-47.534 78.214 0 96.875-36.49 96-39.393l-64 8s26.713-34.049 32-86.419c-11.716 6.386-37.553 24.955-72 90.622 10.3-74.259-15.741-129.526-16-132.2-.259 2.677-26.3 57.944-16 132.2-34.447-65.667-60.284-84.236-72-90.622 5.287 52.37 32 86.419 32 86.419l-64-8c-.875 2.9 17.786 39.393 96 39.393-41.97 9.234-59.05 47.173-59.571 47.534 0 0 57.857 5.747 83.571-28.74z",
  fill: "#5fc4b8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m378.771 249.3a24 24 0 0 0 33.941 0l79.2-79.2c16.97-15.363 2.343-29.99-7.03-39.363l-112.682 112.688z",
  fill: "#f29c9c"
}), /*#__PURE__*/React.createElement("path", {
  d: "m247.829 69.267h160v31.917h-160z",
  fill: "#f29c9c",
  transform: "matrix(.707 -.707 .707 .707 35.756 256.772)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248.029 384-64 8s26.695-34.027 31.994-86.368c-21.692 53.096-80.023 110.368-111.994 117.761-41.97 9.234-59.05 47.173-59.571 47.534 0 0 57.857 5.748 83.571-28.74 25.714 34.488 83.571 28.74 83.571 28.74-.521-.361-17.6-38.3-59.571-47.534 78.214 0 96.871-36.493 96-39.393z",
  fill: "#50b5a6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m489.271 43.02c-4.054 5.818-10.622 14.845-19.507 25.748l5.173 5.173-11.314 33.941-14.923-14.923c-47.262 50.839-128.885 117-232.7 115.3v15.741h134.486l21.714 19.425 112.679-112.68 17.3-49.108a32 32 0 0 0 -7.555-33.261z",
  fill: "#d65858"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 328,
  cy: 144,
  fill: "#f29c9c",
  r: 16
}), /*#__PURE__*/React.createElement("circle", {
  cx: 364,
  cy: 116,
  fill: "#f29c9c",
  r: 12
}), /*#__PURE__*/React.createElement("g", {
  fill: "#97e5de"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 128.571,
  cy: 327.429,
  r: 8.571
}), /*#__PURE__*/React.createElement("circle", {
  cx: 134.286,
  cy: 350.286,
  r: 5.714
}), /*#__PURE__*/React.createElement("circle", {
  cx: 65.6,
  cy: 353.6,
  r: 9.6
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81.6,
  cy: 369.6,
  r: 6.4
}))), /*#__PURE__*/React.createElement("g", {
  id: "Outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "m247.037 376.062-47.02 5.877a194.98 194.98 0 0 0 23.972-75.554 8.006 8.006 0 0 0 -11.789-7.828c-18.673 10.178-38.05 31.389-57.8 63.221.055-40.185-7.668-67.735-18.566-99.55a8 8 0 0 0 -7.8-6.228c-6.031 0-7.372 5.114-8.633 8.483a275.648 275.648 0 0 0 -17.736 97.294c-19.753-31.832-39.129-53.042-57.8-63.22a8.006 8.006 0 0 0 -11.789 7.828 194.978 194.978 0 0 0 23.973 75.554l-47.028-5.877c-5.954-.74-14.581 5.552-3.794 20.072 6.4 8.611 24.357 26.5 65.991 32.908-14.4 9.713-25.179 22.431-33.472 37.531a8.006 8.006 0 0 0 5.921 12.315c23.517 2.321 55.634-2.752 76.362-17.8v34.912h-32.029a8 8 0 0 0 0 16h80a8 8 0 0 0 0-16h-31.971v-34.9c30.339 22.018 74.195 18 76.363 17.787 5.092-.506 9.406-5.919 5.737-12.654a104.974 104.974 0 0 0 -33.288-37.192c51.849-7.985 74.08-36.647 70.847-47.351a8 8 0 0 0 -8.651-5.628zm-95.008 39.332c-9.52 0-11.011 13.768-1.718 15.813 23.052 5.071 38.059 19.572 47.033 31.971-17.419-.623-47.349-4.914-62.9-25.773a8 8 0 0 0 -12.826 0c-15.554 20.862-45.487 25.152-62.9 25.774 8.973-12.4 23.978-26.9 47.033-31.971 9.3-2.046 7.8-15.813-1.719-15.813-26.1 0-58.334-4.569-78.485-21.143l45.493 5.687a8 8 0 0 0 7.295-12.866c-.221-.282-19.211-25.031-27.449-63.81 14.059 12.571 32.414 35.389 54.062 76.657 4.146 7.907 16.235 4.027 15.008-4.815a250.9 250.9 0 0 1 8.073-106.005 250.933 250.933 0 0 1 8.071 106c-1.226 8.842 10.863 12.721 15.008 4.815 21.649-41.268 40-64.086 54.063-76.657-8.238 38.779-27.228 63.527-27.441 63.8a8.006 8.006 0 0 0 7.286 12.876l45.493-5.687c-20.137 16.576-52.385 21.147-78.48 21.147z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m500.284 42.719-31-31a39.735 39.735 0 0 0 -28.284-11.719c-23.817 0-32.755 18.314-45.255 28.687l-16.97-16.971a8 8 0 0 0 -11.315 0l-46.631 46.627a8 8 0 1 0 11.315 11.314l40.969-40.971 11.255 11.255-101.823 101.823-11.255-11.254 20.854-20.853a8 8 0 0 0 -11.315-11.314c-25.564 26.621-28.852 26.395-28.852 32.167 0 5.808 2.913 5.139 33.4 36.709l-71.23 17a8 8 0 0 0 -6.147 7.781v32a8 8 0 0 0 8 8h131.43l25.853 23.128a32.037 32.037 0 0 0 45.086-.168l79.061-79.06c13.2-12.062 15.3-27.735-3.346-47.206l15.643-44.4a40.205 40.205 0 0 0 -9.443-41.575zm-14.034 121.732-79.194 79.195c-11.051 11.047-23.117-.508-23.22-.545l100.926-100.926c9.97 11.2 8.016 15.748 1.488 22.276zm8.386-85.472-16.7 47.393-106.043 106.045c-15.371-12.982-16.247-16.417-21.407-16.417h-126.486v-17.685l79-18.855a8 8 0 0 0 3.8-13.438l-12.945-12.944c145.177-145.178 48.158-48.206 130.169-130.049a23.989 23.989 0 0 1 33.942 0l31 31a24.125 24.125 0 0 1 5.67 24.95z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m446.653 34.343a8 8 0 0 0 -11.314 0c-21.339 22.362-24.971 22.543-24.971 28.284 0 5.9 1.636 3.8 47.6 50.912a8 8 0 0 0 13.247-3.127l11.314-33.941a8 8 0 0 0 -1.932-8.187zm13.474 58.73-30.445-30.446 11.318-11.314 24.784 24.787z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 200,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 184,
  cy: 232,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 232,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 208,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 264,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 168,
  cy: 296,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 152,
  cy: 200,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 264,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 104,
  cy: 232,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88,
  cy: 296,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 304,
  cy: 80,
  r: 8
})));

var SvgWatering = function SvgWatering(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatering, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watering.e4ca3e5e.svg";
export { ForwardRef as ReactComponent };